import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLiveRefresh } from "@/hooks/useLiveRefresh";
import { DataFreshness } from "@/components/v3/DataFreshness";
import { SourceCoverage } from "@/components/v3/SourceCoverage";
import { ReportViewSelector } from "@/components/v3/ReportViewSelector";
import { CeoPulse } from "@/components/v3/CeoPulse";
import { CeoTrends } from "@/components/v3/CeoTrends";
import CockpitLive from "@/components/v3/CockpitLive";

export default function LiveCockpit() {
  const [version, refresh] = useLiveRefresh();
  const [dates, setDates] = useState([]), [dateError, setDateError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    api.get("/portfolio/as-of-dates", { signal: controller.signal }).then(r => { setDates(r.data.dates); setDateError(false); })
      .catch(e => { if (e.code !== "ERR_CANCELED") setDateError(true); });
    return () => controller.abort();
  }, [version]);
  return <div className="ceo-page p-4 sm:p-6 lg:p-8 max-w-[1520px] financial-report" data-testid="ceo-cockpit">
    <header className="flex flex-wrap items-start justify-between gap-5 mb-6"><div><div className="ceo-label !text-[#b3122a]">Red Fort Capital Loan Pulse · Decision Intelligence</div><h1 className="ceo-fig text-4xl mt-1">CEO Cockpit</h1><p className="text-sm text-slate-500 mt-2" data-testid="cockpit-live-basis">Live LMS activity · separate HQ operations · historical portfolio available by reporting date</p></div><ReportViewSelector dates={dates} /></header>
    {dateError && <div role="alert" data-testid="cockpit-history-dates-error" className="report-warning">Historical reporting dates could not be refreshed. Live activity remains separate.</div>}
    <CeoTrends />
    <DataFreshness version={version} onRefresh={refresh} prefix="cockpit" />
    <SourceCoverage version={version} />
    <CeoPulse />
    <CockpitLive refreshKey={version} />
  </div>;
}